/**
 * Формирование корректного урла для файлов cdn
 *
 * `folderPath` - список папок через `/`
 *
 * `fileName` - имя файла с расширением
 *
 * допустип файл с названием `image.jpeg` лежит в папке `onboarding/store`
 * @example
 *
 * getCDNPath(`onboarding/store`, `image.jpeg`) => `https://cdn.centra.ai/app-static/o/onboarding/store/image.jpeg`
 */
export const getCDNPath = (folderPath: string, fileName: string) => {
  const cleanFolderPath = folderPath ? folderPath.replace(/\/+$/, '') : '';
  const cleanFileName = fileName ? `${fileName}` : '';
  const separator = cleanFolderPath && cleanFileName ? '/' : '';
  return `https://cdn.centra.ai/app-static/o/${cleanFolderPath}${separator}${cleanFileName}`;
};
